<template>
    <div>
        <v-row class="ml-n5 mt-2">

            <v-col cols="8">
            <!-- Entry Type selector chips for LABEL COMPANIES -->
            <!-- why dependent on local object, company is a global setting -->
            <!-- this.$store.getters.getSelectedOverAllCompany.context == 2 = LABEL -->
            <!-- <template v-if="this.searchObject.company == 'label'"> -->
            <template v-if="companyIsLabel">
                <v-chip
                    v-for="(item, index) in entryTypesForLabelCompanies"
                    :key="index"
                    @click="changeEntryTypes(item)"
                    :color="getSearchType == item.search ? 'selectedChip' : 'standard'"
                    class="ml-2 pl-4 pr-4"
                >
                    <div :alvqa="alvqa + '-entry-type-chip-' + item.search">
                        {{ item.text }}
                    </div>
                </v-chip>
            </template>

            <!-- Entry Type selector chips for PUBLISHING COMPANIES -->
            <template v-else>
                <v-chip
                    v-for="(item, index) in entryTypesForPublishingCompanies"
                    :key="index"
                    @click="changeEntryTypes(item)"
                    :color="getSearchType == item.search ? 'selectedChip' : 'standard'"
                    class="ml-2 pl-4 pr-4"
                >
                    <div :alvqa="alvqa + '-entry-type-chip-' + item.search">
                        {{ item.text }}
                    </div>
                </v-chip>
            </template>
            </v-col>
        </v-row>

        <v-row>

            <v-col cols="12">
            <!-- Product TITLE: can be Label (Track, Release) or Publishing (Work, Sheet, Release) -->
            <!-- returnObject=false and itemValue, otherwise the Autocomplete returns the whole object -->

            <!-- ADD ROW - PRODUCT autocomplete search -->
            <template v-if="(getSearchType != 'label/freetext') && (getSearchType != 'publishing/freetext') && (isNewSearch)">
            <!-- :returnObject="false" -->
                <BaseEditPageAutocomplete
                    :context="context +'InvoiceRows'"
                    field="Title"
                    :label="autocompleteSearchCaption"
                    rules="required"
                    :withFreeText="false"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-title'"
                    itemValue="alvId"
                >
                    <!-- selected product -->
                    <template v-slot:selection="{ item }">
                        <div class="ellipsis" :alvqa="alvqa + '-autocomplete-invoices-invoicerows-title'">
                            {{ titleSelection(item) }}
                        </div>
                    </template>

                    <!-- dropdown list of options -->
                    <template v-slot:items="{ items }">
                        <v-list-item-content :alvqa="alvqa + '-autocomplete-invoices-invoicerows-title-dropdown'">
                            <v-list-item-title :alvqa="alvqa + '-autocomplete-invoices-invoicerows-title-dropdown'">
                                {{ titleDropdown(items) }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </template>
                </BaseEditPageAutocomplete>
            </template>

            <!-- ADD ROW - FREETEXT entry -->
            <template v-else-if="getSearchType === 'label/freetext' || getSearchType === 'publishing/freetext'">
                <BaseEditPageTextField
                    :context="context +'InvoiceRows'"
                    field="Title"
                    :clearable="true"
                    rules="required"
                    :label="$t('lang_GENERIC_CAPTION_FREETEXT')"
                    :alvqa="alvqa + '-textfield-freetext'"
                    :withMargin="false"
                />
            </template>

            <!-- EDIT ROW (TITLE READ-ONLY) FOR PRODUCTS AND FREETEXT -->
            <template v-else>
                <BaseEditPageTextField
                    :context="context +'InvoiceRows'"
                    field="TitleReadOnly"
                    :clearable="false"
                    :label="getSearchCaption"
                    :alvqa="alvqa + '-textfield-tag'"
                    :withMargin="false"
                    :disabled="true"
                />
            </template>
        <!-- </template> -->

        </v-col>

        </v-row>

        <v-row>

            <!-- Batch -->
            <v-col cols="3" v-if="getSearchType == 'label/releases' || getSearchType == 'publishing/releases'">
                <BaseEditPageDropdown
                    :context="context +'InvoiceRows'"
                    field="Batch"
                    :items="dropdownBatches"
                    :label="$t('lang_ERP_SHIPPING_CAPTION_BATCH')"
                    :selection="true"
                    :withMargin="false"
                    rules="required"
                    :alvqa="alvqa + '-dropdown-batch'"
                />
            </v-col>

            <!-- Quantity -->
            <v-col cols="3">
                <BaseEditPageTextField
                    :context="context +'InvoiceRows'"
                    field="Quantity"
                    :label="$t('lang_GENERIC_CAPTION_QUANTITY')"
                    :withMargin="false"
                    :additionalFunction="updateSum()"
                    :alvqa="alvqa + '-textfield-quantity'"
                />
            </v-col>

            <!-- Price -->
            <v-col cols="3">
                <BaseEditPageTextField
                    :context="context +'InvoiceRows'"
                    field="Price"
                    :label="$t('lang_GENERIC_CAPTION_PRICE') + ' ' + this.$store.getters.getInvoicesDetailsCurrency"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-price'"
                    rules="positiveOrNegativeWithMaxFourDigits"
                />
            </v-col>

            <!-- VAT -->
            <v-col cols="3">
                <BaseEditPageTextField
                    :context="context +'InvoiceRows'"
                    field="Vat"
                    :label="$t('lang_GENERIC_CAPTION_VAT') + ' %'"
                    :withMargin="false"
                    :alvqa="alvqa + '-textfield-vat'"
                />
            </v-col>

        </v-row>
    </div>
</template>
<script>

import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import { DropdownErpShippingBatches } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "InvoiceRowsEditPanelDialog",
    components: {
        BaseEditPageDropdown,
        BaseEditPageTextField,
        BaseEditPageAutocomplete,
    },
    data() {
        return {
            context: "Invoices",
            alvqa: "erp-invoices-edit-panel-invoicerows-dialog",
            searchObject: {
                // when dialog is opened from an existing invoice row, set searchObject based on data
                // set all to null, and have a new method to populate with condition from above, mounted()?
                company: this.$store.getters.getSelectedOverAllCompany.context == 2 ? "label" : "publishing",
                search: null,
                caption: ""
            },
            fetchPrice:null
        }
    },
    created() {
        let searchType = this.$store.getters.getInvoicesInvoiceRowsTitleSearch
        if (this.companyIsLabel) {
            let result = this.entryTypesForLabelCompanies.find(function(post, index) {
                if(post.search == searchType)
                    return true;
            });
            this.searchObject.caption = result.caption
        } else {
            let result = this.entryTypesForPublishingCompanies.find(function(post, index) {
                if(post.search == searchType)
                    return true;
            });
            this.searchObject.caption = result.caption
        }
    },
    computed: {
        autocompleteSearchCaption() {
            return this.getSearchCaption // this.$t(this.searchObject.caption)
        },
        companyIsLabel() {
            return this.$store.getters.getSelectedOverAllCompany.context == 2 ? true : false
        },
        dropdownBatches() {
            return DropdownErpShippingBatches
        },
        entryTypesForLabelCompanies() {
            return [
                {   text: this.$t('lang_LABEL_TRACKS'),
                    search: "label/tracks",
                    caption: "lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_TRACKS" },

                {   text: this.$t('lang_LABEL_RELEASES'),
                    search: "label/releases",
                    caption: "lang_ERP_INVOICES_CAPTION_INVOICEROWS_DIALOG_SEARCH_LABEL_RELEASES" },

                {   text: this.$t('lang_GENERIC_CAPTION_FREETEXT'),
                    search: "label/freetext",
                    caption: "lang_GENERIC_CAPTION_FREETEXT" },
            ]
        },
        entryTypesForPublishingCompanies() {
            return [
                {   text: this.$t('lang_PUBLISHING_CAPTION_WORKS'),
                    search: "publishing/works",
                    caption: "lang_PUBLISHING_CAPTION_WORKS" },

                {   text: this.$t('lang_PUBLISHING_CAPTION_SHEETS'),
                    search: "publishing/sheets",
                    caption: "lang_PUBLISHING_CAPTION_SHEETS" },

                {   text: this.$t('lang_PUBLISHING_CAPTION_PROJECTS'),
                    search: "publishing/releases",
                    caption: "lang_PUBLISHING_CAPTION_PROJECTS" },

                {   text: this.$t('lang_GENERIC_CAPTION_FREETEXT'),
                    search: "publishing/freetext",
                    caption: "lang_GENERIC_CAPTION_FREETEXT" },
            ]
        },
        getSearchType() {
            let type = this.$store.getters.getInvoicesInvoiceRowsTitleSearch
            return type
        },
        getSearchCaption() {
            let type = this.getSearchType
            if (this.companyIsLabel) {
                let result = this.entryTypesForLabelCompanies.find(function(post, index) {
                    if(post.search == type)
                        return true;
                });
                return this.$t(result.caption)
            } else {
                let result = this.entryTypesForPublishingCompanies.find(function(post, index) {
                    if(post.search == type)
                        return true;
                });
                return this.$t(result.caption)
            }
        },
        getTitleOfExistingRow() {
            return this.$store.getters.getInvoicesInvoiceRowsDetailsTitle
        },
        isNewSearch() {
            let isNewSearch = this.$store.getters.getInvoicesInvoiceRowsIsNewSearch
            return isNewSearch
        }
    },
    methods: {
        changeEntryTypes(item) {
            if (this.isNewSearch) {
                this.$store.commit('setInvoicesInvoiceRowsDetailsTitle', null)
                this.$store.commit('setInvoicesInvoiceRowsTitleOptions', [])
                this.$store.commit('setInvoicesInvoiceRowsTitleSearch', item.search)
                this.$store.commit('setInvoicesInvoiceRowsDetailsType', item.search)
            }
        },
        updateSum() {
            let quantity = this.$store.getters.getInvoicesInvoiceRowsDetailsQuantity
            let price = this.$store.getters.getInvoicesInvoiceRowsDetailsPrice
            let sum = this.$alvPlugin.stringToNumber(quantity) * this.$alvPlugin.stringToNumber(price)
            this.$store.commit('setInvoicesInvoiceRowsDetailsSum', sum)
        },

        titleDropdown(item) {
            if (this.companyIsLabel) {
                if (this.getSearchType == "label/tracks") {
                    return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelTracks(item) + ')'
                } else if (this.getSearchType == "label/releases") {
                    return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelReleases(item) + ')'
                }
            } else {
                if (this.getSearchType == "publishing/works") {
                    return item.title + ' (' + item.gemaNumber + ')';
                } else if (this.getSearchType == "publishing/sheets") {
                    return item.title;
                } else if (this.getSearchType == "publishing/releases") {
                    return item.title;
                }
            }
        },

        titleSelection(item) {
            if (item.connectionId) {
                // EDIT ROW - do I need to write type to store here?
                // this.$store.commit('setInvoicesInvoiceRowsDetailsConnectionId', item.connectionId)
                // this.$store.commit('setInvoicesInvoiceRowsTitleSearch', this.getSearchType)
                // TODO_PT: improve to connectionObject.ean/isrc/catalogNumber/workId...etc
                return item.title + ' (' + item.connectionId + ')';
            } else {
                // ADD ROW - do I need to write type to store here?
                this.$store.commit('setInvoicesInvoiceRowsTitleSearch', this.getSearchType)
                this.$store.commit('setInvoicesInvoiceRowsDetailsConnectionId', item.alvId)
                this.$store.commit('setInvoicesInvoiceRowsDetailsType', this.getSearchType)
                this.$store.commit('setInvoicesInvoiceRowsDetailsProductId', this.$alvPlugin.getProductItemId(item))
                // if BE returns price and currency, commit price to setInvoicesInvoiceRowsDetailsPrice
                if (item.priceForInvoice) {
                    let price = item.priceForInvoice.price
                    if (price != null && price != '') this.$store.commit('setInvoicesInvoiceRowsDetailsPrice', this.$n(this.$alvPlugin.stringToNumber(price, 'number')))
                } else if(!this.$store.getters.getInvoicesInvoiceRowsDetailsPrice) {
                  const releaseId = this.$store.getters.getInvoicesInvoiceRowsEditingDialogDetails.title.id;
                  const invoiceId = this.$store.getters.getInvoicesDetails.id;
                  if(!this.fetchPrice) {
                    this.fetchPrice = this.$store.dispatch('fetchPriceForInvoiceEditPanel', {
                      releaseId,
                      invoiceId
                    }).then(price => {
                      if(!(price instanceof String || typeof price === "number")) {
                          return
                      }

                      price = this.$alvPlugin.floatToString(price)
                      this.$store.commit('setInvoicesInvoiceRowsDetailsPrice', price)
                      this.fetchPrice = null;
                    }).catch(error=>{
                      this.fetchPrice = null;
                    });
                  }
                }

                switch (this.getSearchType) {
                    case "label/tracks":
                        return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelTracks(item) + ')'
                        break;
                    case "label/releases":
                        return item.title + ' (' + this.$alvPlugin.getProductItemIdLabelReleases(item) + ')'
                        break;
                    case "publishing/works":
                        return item.title + ' (' + item.gemaNumber + ')'
                        break;
                    case "publishing/sheets":
                        return item.title
                        break;
                    case "publishing/releases":
                        return item.title
                        break;
                    default:
                        return "Error in type of invoice row"
                        break;
                }
            }
        },
    }
}
</script>
